"use client";

import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionItemProps,
  AccordionPanel,
  Box,
  Heading,
  HeadingProps,
  Stack,
  Text,
} from "@chakra-ui/react";
import { FaPlus } from "react-icons/fa";

type Faq_T = {
  question: string;
  answer: any;
};

export interface Faqs_T {
  title: string;
  faqs: Faq_T[];
  renderAnswer: (answer: any) => any;
  headerProps?: HeadingProps;
  itemProps?: AccordionItemProps;
  containerWidth?: string;
  textColor?: string;
  titleColor?: string;
  from?: string;
  style?: any;
}

export const FAQSection = (props: Faqs_T) => {
  const {
    title,
    faqs,
    renderAnswer,
    headerProps,
    itemProps,
    containerWidth,
    textColor,
    titleColor,
    from,
  } = props;

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs?.map((faq) => ({
      "@type": "Question",
      name: faq?.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq?.answer?.text,
      },
    })),
  };
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <Box
        as="section"
        w={{
          xl: containerWidth,
        }}
        mx={{ base: "unset", md: "auto" }}
        pl={{
          md: from === "b2b-landing" ? 0 : 5,
          lg: 0,
        }}
        py={from === "b2b-landing" || from === "b2c" ? 0 : 10}
        alignSelf="center"
      >
        <Stack
          direction={{
            base: "column",
            lg: from === "b2b-landing" ? "row" : "column",
          }}
          mx="auto"
          w="100%"
          spacing={{
            base: "6",
            lg: "12",
          }}
          textAlign="center"
        >
          <Heading
            as="h1"
            color={titleColor ? titleColor : "black"}
            fontSize={{
              base: 26,
              md: 34,
              lg: 38,
              xl: 45,
            }}
            lineHeight="shorter"
            fontWeight={"bold"}
            textAlign={{
              base: from === "b2b-landing" ? "left" : "center",
              md: from === "about" ? "center" : "left",
            }}
            textTransform="capitalize"
            letterSpacing="tight"
            id="faqs"
            w={{
              xl: from === "b2b-landing" || from === "about" ? "40%" : "full",
            }}
            mx={"auto"}
            {...headerProps}
          >
            {title}
          </Heading>
          <Accordion
            allowToggle
            textAlign="left"
            defaultIndex={from === "b2b-landing" ? undefined : 0}
            color={textColor ? textColor : "black"}
            w={{
              base: from === "b2b-landing" ? "full" : "",
              lg: from === "about" ? "65%" : undefined,
              xl:
                from === "b2b-landing"
                  ? "70%"
                  : from === "about"
                  ? "50%"
                  : "full",
            }}
            mx={"auto"}
          >
            {faqs?.map((faq, idx) => (
              <AccordionItem key={idx} {...itemProps} borderStyle="none">
                <AccordionButton
                  fontWeight="medium"
                  _expanded={{
                    fontWeight: "bold",
                  }}
                  borderTop={idx !== 0 ? "1px solid black" : "none"}
                  pb={6}
                >
                  <Box
                    as="h3"
                    flex="1"
                    textAlign="left"
                    fontSize={{
                      base: "md",
                      lg: "lg",
                    }}
                  >
                    {faq.question}
                  </Box>
                  <FaPlus fontSize="16px" />
                </AccordionButton>
                <AccordionPanel
                  pt={3}
                  pb={4}
                  sx={{
                    p: {
                      mb: "4",
                    },
                  }}
                >
                  {renderAnswer ? (
                    renderAnswer(faq.answer)
                  ) : (
                    <Text mt={3}>{faq?.answer}</Text>
                  )}
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </Stack>
      </Box>
    </>
  );
};
